import React, { useState } from 'react'
import { CircularProgress, Button, Dialog, DialogContent, DialogTitle, DialogActions } from '@material-ui/core';
import { DropzoneArea } from "material-ui-dropzone";
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import PageLoader from '../PageLoader';
import { useSnackbar } from 'notistack';
import { globalExportService, globalFileUploadService } from '../../../utils/globalApiServices';
import { checkApiStatus, downloadFileType } from '../../../utils';
import { globalPostService } from '../../../utils/globalApiServices';

function ImportFileModule({ toggleModalFn, getResponseBack, title, moduleName, importUrl, downloadSamplUrl }) {
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();
	const [file, setFile] = useState([]);
	const [isLoading, setLoading] = useState(false)
	const [previewFile, setPreviewFile] = useState({ modal: false, data: null, singlepreview: null })
	const downloadSample = (query) => {
		globalExportService(downloadSamplUrl, query)
			.then(response => {
				if (checkApiStatus(response)) {
					downloadFileType(response.data, `${moduleName}`, 'xlsx')
					enqueueSnackbar("Sample File Download Successfully", { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } })
				} else {
					enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } })
				}
			});
	}

	const importFile = () => {
		var formData = new FormData();
		formData.append('file', file[0])
		setLoading(true);
		globalFileUploadService(importUrl, formData)
			.then(response => {
				setLoading(false); toggleModalFn(); getResponseBack()
				if (checkApiStatus(response)) {
					enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, })
				} else {
					enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
				}
			})
	}
	const handleChipClick = (event) => {
		setLoading(true);
		if (event.endsWith('.xlsx') || event.endsWith('.xls')) {
			let formData = new FormData();
			formData.append('file', file?.find(item => item?.path === event));
			globalPostService(`camo/preview/file/`, formData)
				.then(response => {
					if (checkApiStatus(response)) {
						setLoading(false);
						setPreviewFile({ modal: true, data: response?.data, singlepreview: false })
					}
				});
		} else {
			setLoading(false);
			setPreviewFile({ modal: true, data: [file?.find(item => item?.path === event)], singlepreview: true })
		}
	};

	return (
		<>


			<Dialog
				open={true}
				onClose={toggleModalFn}
				className='import-file-modal'
				maxWidth={'md'}
			>
				<DialogTitle id="scroll-dialog-title">
					{title ? title : "Import File"}
				</DialogTitle>
				<DialogContent dividers={true}>
					<div style={{ width: '380px' }}>
						{downloadSamplUrl ? <p style={{ marginBottom: '5px' }}>Please refer the sample sheet, <span style={{ color: '#3f51b5', cursor: 'pointer' }} onClick={() => downloadSample({ download: 'xls', download_sample: 'true' })}>Download</span></p> : null}
						<div>
							<DropzoneArea
								filesLimit={1}
								maxFileSize={104857600}
								acceptedFiles={['.xlsx']}
								showPreviewsInDropzone={false}
								useChipsForPreview={true}
								showPreviews={true}
								dropzoneText={<p>Drag & Drop file Or Click Here </p>}
								dropzoneClass="drag-drop-cnt"
								maxWidth="sm"
								showAlerts={['info', 'error']}
								alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
								clearOnUnmount={true}
								onChange={(file) => setFile(file)}
								previewChipProps={{
									onClick: (event) => {
										handleChipClick(event?.target.textContent);
									}
								}}
							/>
						</div>
					</div>
					<span style={{ fontSize: '11px' }} className='files-upload-limit' > Note : Supported extension only ('.xlsx').</span>
				</DialogContent>
				<DialogActions>
					<Button disabled={isLoading} onClick={toggleModalFn} color='primary' size='small' variant='outlined'>CLOSE</Button>
					<Button disabled={isLoading || !file.length} onClick={importFile} color='primary' size='small' variant='contained'>
						{isLoading ? <CircularProgress size={24} color='white' /> : 'SAVE'}
					</Button>
				</DialogActions>
				{isLoading ? <PageLoader /> : null}
			</Dialog>

			{
				previewFile?.modal ?
					<Dialog
						open={previewFile?.modal}
						onClose={() => setPreviewFile({ modal: false, data: null })}
						style={{ height: "100vh" }}
						fullWidth
						maxWidth="lg"
					>
						<DialogTitle>File Preview</DialogTitle>
						<DialogContent dividers>
							{previewFile?.singlepreview ? previewFile?.data?.map((file, index) => (
								<div key={index}>
									{
										file?.type === 'application/pdf' ? (
											<object type="text/html" data={URL.createObjectURL(file)} style={{ width: '100%', height: '100vh' }}>
												<param name="type" value="text/html" />
											</object>
										) : file.type.startsWith('image/') && (
											<img src={URL.createObjectURL(file)} alt={file.name} style={{ width: '100%', height: '100vh' }} />
										)
									}
								</div>
							))
								:
								previewFile?.data?.file_name?.endsWith('.xls') || previewFile?.data?.file_name?.endsWith('.xlsx') ?
									<div>
										<iframe src={'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(previewFile?.data?.file_url)} width='100%' height={window.innerHeight} frameborder='0'></iframe>
									</div> : null
							}
						</DialogContent>
						<DialogActions>
							<Button onClick={() => setPreviewFile({ modal: false, data: null })} color="primary" size="small" variant="outlined">CLOSE</Button>
						</DialogActions>
					</Dialog> : null}
		</>

	)
}
export default withRouter(ImportFileModule) 